module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('workspace', [_c('div', {
    attrs: {
      "slot": "form"
    },
    slot: "form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "teaser"
    }
  }, [_vm._v("Teaser")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.teaser),
      expression: "teaser"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "teaser"
    },
    domProps: {
      "value": (_vm.teaser)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.teaser = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "blurb"
    }
  }, [_vm._v("Blurb")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blurb),
      expression: "blurb"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "blurb"
    },
    domProps: {
      "value": (_vm.blurb)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.blurb = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "buttonText"
    }
  }, [_vm._v("Button Text")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.buttonText),
      expression: "buttonText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "blurb"
    },
    domProps: {
      "value": (_vm.buttonText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.buttonText = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "coverImageSrc"
    }
  }, [_vm._v("Cover Image URL")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coverImageSrc),
      expression: "coverImageSrc"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "coverImageSrc"
    },
    domProps: {
      "value": (_vm.coverImageSrc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.coverImageSrc = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "url"
    }
  }, [_vm._v("Link")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "url"
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  }), _c('p', {
    staticClass: "help-block"
  }, [_vm._v("For cover image and button")])]), _c('div', {
    staticClass: "form"
  }), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "for": "color"
    }
  }, [_vm._v("Color")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.color),
      expression: "color"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "color",
      "name": "color"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.color = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jaoa.colors), function(jaoaColor) {
    return _c('option', {
      domProps: {
        "value": jaoaColor.toLowerCase()
      }
    }, [_vm._v(_vm._s(jaoaColor))])
  }), 0)]), _c('div', {
    staticClass: "form-group clearfix",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "id": "refresh"
    },
    on: {
      "click": _vm.reset
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-refresh"
  }), _vm._v(" Reset")]), _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyHtml",
      "aria-label": "Copied HTML!"
    },
    on: {
      "click": _vm.copy
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy HTML")]), _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "id": "copyTextVersion",
      "data-component": _vm.currentTemplate,
      "aria-label": "Copied Text!"
    },
    on: {
      "click": _vm.copyTextVersion
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-copy"
  }), _vm._v(" Copy text")])])])]), _c('tr', {
    attrs: {
      "slot": "render"
    },
    slot: "render"
  }, [_c('td', [_c('table', {
    staticStyle: {
      "table-layout": "fixed"
    },
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "padding": "40px 0px 40px 0px"
    },
    attrs: {
      "align": "center",
      "bgcolor": "#ffffff"
    }
  }, [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "520"
    }
  }, [_c('tr', [_c('td', [_c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "31%",
      "align": "left"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "padding",
    staticStyle: {
      "border": "1px solid #cccccc"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "http://jaoa.org/Issue.aspx",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "display": "block",
      "padding": "0",
      "color": "#ffffff",
      "font-family": "Helvetica, arial, sans-serif",
      "font-size": "16px"
    },
    attrs: {
      "src": _vm.coverImageSrc,
      "width": "188",
      "height": "260",
      "border": "1",
      "alt": "JAOA cover"
    }
  })])])])]), _c('table', {
    staticClass: "wrapper",
    attrs: {
      "border": "0",
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "58%",
      "align": "right"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "mobile-text-center",
    style: (_vm.teaserStyle)
  }, [_vm._v(_vm._s(_vm.teaser))])]), _c('tr', [_c('td', {
    staticClass: "intro-text",
    staticStyle: {
      "padding": "0 0 20px 0",
      "font-family": "'Roboto', Helvetica, arial, sans-serif",
      "font-weight": "normal",
      "font-size": "16px",
      "text-align": "left",
      "line-height": "20px",
      "color": "#666666"
    }
  }, [_vm._v(_vm._s(_vm.blurb))])]), _c('tr', [_c('td', {
    staticClass: "padding"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('a', {
    staticClass: "body-text",
    style: (_vm.buttonStyle),
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_vm._v(" " + _vm._s(_vm.buttonText) + " ")])])])])])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2684c9e0"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jaoa/intro.vue
// module id = 217
// module chunks = 0